import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>It is important to be aware of the factors that influence our
                                                decision making in order to prevent
                                                them from having a negative impact. This tool is about<span
                                                    className="green brownbold">  how to make timely decisions</span> and
                                                will
                                                help you increase awareness of the key elements to decision
                                                making as well as helping you make
                                                decisions in a timely manner.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                FACTORS INFLUENCING DECISION MAKING
           </span></div>
                                            <p>There is much involved in leadership, including the ability
                                                to think strategically, plan ahead and
                                                demonstrate the skills and imagination needed to direct and
                                                motivate others. Ultimately, however,
                                                assessment of a leader’s effectiveness or otherwise depends
                                                on the decisions he or she makes.</p>
                                            <p>Most people in business who believe their decision making is
                                                logical and rational may be surprised
                                                to learn that the process is inevitably affected by personal
                                                bias, social and other influences. Did
                                                you realise, for example, that you’ll make decisions more
                                                effectively when you’re in a good mood?<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a></p>

                                            <p>Decisions reached by groups are subject to different
                                                influences than those made individually.
                                                They can benefit from the additional, diverse thought and
                                                intelligence available. However, such
                                                advantages may also be counteracted by the kinds of social
                                                influences which result in conformity,
                                                or ‘groupthink’.</p>
                                            <p>In the following two sections, we’ll describe the most
                                                significant ways in which group and
                                                individual decision making can be influenced.</p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                INFLUENCES ON INDIVIDUAL DECISION MAKERS
                </span></div>
                                            <div className="border_subtitle">Personal style</div>
                                            <p> Whether you make your decisions according to your ‘gut
                                                instinct’, or after collecting as much
                                                information as possible, this will affect the
                                                appropriateness or effectiveness of your decisions. If
                                                working as part of a group, it will influence the way you
                                                interact with others. Of course, most of
                                                us think we ‘know’ how we do things, but you might be
                                                surprised by the result of a personality
                                                questionnaire such as the Myers Briggs Type Indicator
                                                (MBTI)®, Saville Wave® or Occupational
                                                Personality Questionnaire (OPQ)®. If you’re interested, get
                                                in touch with us.</p>

                                            <div className="border_subtitle">Expertise</div>
                                            <p>It’s easy to assume that those who know most about an issue
                                                are best able to make an effective
                                                decision about it, but they’re just as likely to spend more
                                                time evaluating their information than
                                                deciding what to do with it.</p>

                                            <div className="border_subtitle">Use of heuristics</div>
                                            <p>Heuristics are ‘rules of thumb’, educated guesses, intuitive
                                                judgements or just ‘common sense’.
                                                For example: ‘Snakes can be dangerous, take care to avoid
                                                them’. More precisely, heuristics are
                                                simple rules for dealing with all likely outcomes for a
                                                particular subject or issue.</p>
                                            <p>People often resort to heuristics, or their previous, limited
                                                personal experience as shortcuts
                                                through the otherwise complex data necessary to decision
                                                making.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}